import { forwardRef, InputHTMLAttributes } from 'react';

import cn from './styles.module.sass';

type IPriceInputProps = InputHTMLAttributes<HTMLInputElement>;

export const PriceInput = forwardRef<HTMLInputElement, IPriceInputProps>(({ ...props }, ref) => (
    <div className={cn.priceInputContainer}>
        <input className={cn.priceInput} ref={ref} {...props} />
    </div>
));
